import { generator, compose, getSpacing } from './theme.js';
import { toPx } from './unit.js';

const cursor = (props) => generator({
    props,
    prop: ['cursor'],
    cssProperty: 'cursor',
});
const display = (props) => generator({
    props,
    prop: ['display'],
    cssProperty: 'display',
});
const position = (props) => generator({
    props,
    prop: ['position'],
    cssProperty: 'position',
});
const top = (props) => generator({
    props,
    prop: ['top'],
    cssProperty: 'top',
    getter: getSpacing,
    transform: toPx,
});
const right = (props) => generator({
    props,
    prop: ['right'],
    cssProperty: 'right',
    getter: getSpacing,
    transform: toPx,
});
const bottom = (props) => generator({
    props,
    prop: ['bottom'],
    cssProperty: 'bottom',
    getter: getSpacing,
    transform: toPx,
});
const left = (props) => generator({
    props,
    prop: ['left'],
    cssProperty: 'left',
    getter: getSpacing,
    transform: toPx,
});
const zIndex = (props) => generator({
    props,
    prop: ['zIndex'],
    cssProperty: 'zIndex',
});
const positions = compose(position, top, right, bottom, left, zIndex);

export { bottom, cursor, display, left, position, positions, right, top, zIndex };
